import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { clearSearchState } from '@/store/search/search.store';
import { outlierSearchTerms } from '@/app/(main)/_components/search-modal/_consts/outlier-search-terms.consts.';

export interface SearchEmptyStateComponentProps {
  setOpen: (open: boolean) => void;
  searchTerm: string;
}

export function SearchEmptyState({
  setOpen,
  searchTerm,
}: SearchEmptyStateComponentProps) {
  const cleanedSearchTerm = searchTerm
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const isOutlier = outlierSearchTerms.some((outlier) =>
    cleanedSearchTerm.includes(outlier),
  );

  const handleButtonClick = () => {
    clearSearchState();
    setOpen(false);
  };

  return (
    <div
      className="w-full mt-3"
      data-testid={DataTestIdEnum.PROCEDURES_MODAL_EMPTY_STATE_CONTAINER}
    >
      {isOutlier && (
        <div
          className="flex flex-col gap-6"
          data-testid={
            DataTestIdEnum.PROCEDURES_MODAL_EMPTY_STATE_OUTLIER_CONTAINER
          }
        >
          <span className="text-base font-gray-800">
            Verifique a disponibilidade em uma de nossas
            {' '}
            <span className="font-bold">unidades físicas</span>
            .
          </span>
          <Button asChild variant="default" color="primary">
            <Link
              prefetch={false}
              data-analytics-term={searchTerm}
              className="md:w-fit"
              href="/unidades-perto-de-voce/"
              onClick={handleButtonClick}
            >
              Ver unidades
            </Link>
          </Button>
        </div>
      )}
      {!isOutlier && (
        <div>
          <span className="text-base font-gray-800">
            Não encontramos resultados para
            {' '}
            <span className="font-bold">{searchTerm}</span>
            . Tente outra
            palavra.
          </span>
        </div>
      )}
    </div>
  );
}
